export function InsertCurveIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M4.86607 7.59032V5.97631H3.35714C3.03663 5.97631 2.7768 5.69838 2.77679 5.35554C2.77679 5.0127 3.03662 4.73477 3.35714 4.73477H4.86607V3.12077C4.86607 2.77793 5.12591 2.5 5.44643 2.5C5.76695 2.5 6.02679 2.77793 6.02679 3.12077V4.73477H7.53571C7.85624 4.73477 8.11607 5.0127 8.11607 5.35554C8.11606 5.69838 7.85623 5.97631 7.53571 5.97631H6.02679V7.59032C6.02679 7.93316 5.76695 8.21109 5.44643 8.21109C5.12591 8.21109 4.86607 7.93316 4.86607 7.59032Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.79082 8.97866L1.5 8.26172L2.72824 7.58271L3.01903 8.29965C3.44832 9.35801 3.9826 10.3686 4.50147 11.0704C4.77342 11.4383 5.02083 11.7245 5.2508 11.8181C5.73938 12.017 6.12223 11.8272 6.45183 11.4597C6.92254 10.9348 7.30071 10.1211 7.67139 9.2825C8.18752 8.1149 8.68267 6.89856 9.26509 6.11673C9.78278 5.4218 10.3785 5.03468 11.0612 5.05857C11.2336 5.06459 12.1473 5.06021 13.0057 6.40315C13.6089 7.34673 14.0632 8.32885 14.1175 8.44238L14.4489 9.1349C14.76 9.80503 13.561 10.5942 13.2625 9.90872L12.9311 9.21619C12.881 9.11148 12.4729 8.22232 11.9166 7.35199C11.5057 6.70918 11.103 6.64728 11.0205 6.64437C10.6231 6.63047 10.3502 7.02496 10.0637 7.49845C9.64215 8.19508 9.27196 9.12121 8.87904 10.0101C8.4338 11.0174 7.95587 11.9766 7.39046 12.607C6.68389 13.3948 5.85076 13.7425 4.80342 13.3162C4.41002 13.1561 3.93793 12.7363 3.4727 12.1071C2.88605 11.3136 2.27618 10.1752 1.79082 8.97866Z"
        fill="currentColor"
      />
    </svg>
  );
}
